import { ICardElementWithChildren } from "backend/model/model";
import React from "react";
import OverallHeader from "../texts/OverallHeader";
import { PerformanceGauge } from "../charts/PerformanceGauge";
import { OverallCard } from "./OverallCard";
import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import { DonutKpiInitiative } from "../charts/DonutKpiInitiative";
import { IChartSelectEvent } from "../charts/types";
import clsx from "clsx";

const useElementOverviewDonutCardStyles = makeThemedStyles(
  "ElementOverviewDonutCard",
  (theme) => ({
    container: {
      marginTop: "-40px",
    },
  })
);

export const ElementOverviewDonutCard = React.memo(
  (
    props: React.PropsWithChildren<{
      data: ICardElementWithChildren[];
      title: string;
      typenames: string[];
      periodName: string;
      disableAnimation?: boolean;
      onSelect?: (value: IChartSelectEvent) => void;
    }>
  ) => {
    const styles = useElementOverviewDonutCardStyles();
    const { data } = props;
    return (
      <OverallCard>
        <OverallHeader title={props.title} periodName={props.periodName} />
        <div className={clsx(styles.container, "chart")}>
          <DonutKpiInitiative
            element={data}
            perfColorKey="rangecolor"
            perfNameKey="rangename"
            typenames={props.typenames}
            onSelect={props.onSelect}
            disableAnimation={props.disableAnimation}
          />
        </div>
      </OverallCard>
    );
  }
);

export default ElementOverviewDonutCard;
